import React, {
  useImperativeHandle,
  forwardRef,
  useRef,
  useEffect,
  useState,
} from "react";
import { Box } from "@mui/material";
import { SpriteAnimator as Animator } from "react-sprite-animator";

// SPRITE IMPORTS
import explosion1 from "../../@shared/assets/sprites/expolsion1.png";
import explosion2 from "../../@shared/assets/sprites/explosion2.png";
import explosion3 from "../../@shared/assets/sprites/explosion3.png";
import explosion4 from "../../@shared/assets/sprites/explosion4.png";
import explosion5 from "../../@shared/assets/sprites/explosion5.png";
import explosion6 from "../../@shared/assets/sprites/explosion6.png";
import explosion7 from "../../@shared/assets/sprites/explosion7.png";
import explosion8 from "../../@shared/assets/sprites/explosion8.png";
import explosion9 from "../../@shared/assets/sprites/explosion9.png";
import explosion10 from "../../@shared/assets/sprites/explosion10.png";
import shinefx from "../../@shared/assets/sprites/shinefx.png";
import starspin from "../../@shared/assets/sprites/starspin.png";
import smokepuff1 from "../../@shared/assets/sprites/smokepuff1.png";
import deadsmoke from "../../@shared/assets/sprites/deadsmoke.png";
import treasure from "../../@shared/assets/sprites/treasure.png";
import deadAshPile from "../../@shared/assets/sprites/dead_ash_pile.png";
import buff1 from "../../@shared/assets/sprites/buff1.png";

//ATTACKS
import voidCircle from "../../@shared/assets/sprites/attacks/Black-hole.png"
import fire from "../../@shared/assets/sprites/attacks/Fire-ball.png"
import lightning from "../../@shared/assets/sprites/attacks/Lightning-bolt.png"
import defaultAttack from "../../@shared/assets/sprites/attacks/Midas-touch.png"
import defaultAttack2 from "../../@shared/assets/sprites/attacks/Sun-strike.png"
import water from "../../@shared/assets/sprites/attacks/Shield.png"
import rock from "../../@shared/assets/sprites/attacks/Spikes.png"

const SpriteAnimator = forwardRef(
  (
    {
      frameWidth,
      frameHeight,
      frameCount,
      fps = 10,
      loop = false,
      animationName,
      wrapAfter,
      onFinish,
      scale,
      style = {},
    },
    ref
  ) => {
    const [shouldAnimate, setShouldAnimate] = useState(true);
    const [playId, setPlayId] = useState(0); // force rerender on new play
    const timeoutRef = useRef(null);

    const spriteMap = {
      voidCircle,
      fire,
      lightning,
      defaultAttack,
      defaultAttack2,
      water,
      rock,
      shinefx,
      starspin,
      smokepuff1,
      deadsmoke,
      treasure,
      deadAshPile,
      buff1,
    };

    const getSpriteSheet = () => spriteMap[animationName] ?? null;

    useImperativeHandle(ref, () => ({
      start: () => {
        setPlayId((id) => id + 1); // restart key
        setShouldAnimate(true);

        // Stop animation if it's not looping
        if (!loop && onFinish) {
          const duration = (frameCount / fps) * 1000;
          clearTimeout(timeoutRef.current);
          timeoutRef.current = setTimeout(() => {
            setShouldAnimate(false);
            onFinish();
          }, duration);
        }
      },
      stop: () => {
        setShouldAnimate(false);
        clearTimeout(timeoutRef.current);
      },
      reset: () => {
        setShouldAnimate(false);
        setPlayId((id) => id + 1);
        clearTimeout(timeoutRef.current);
      },
    }));

    useEffect(() => {
      return () => clearTimeout(timeoutRef.current); // clean up on unmount
    }, []);

    return (
      <Box style={style}>
        <Animator
          key={playId} // force re-render on restart
          sprite={getSpriteSheet()}
          direction="horizontal"
          frameCount={frameCount}
          width={frameWidth}
          height={frameHeight}
          fps={fps}
          shouldAnimate={shouldAnimate}
          loop={loop}
          startFrame={0}
          wrapAfter={wrapAfter}
          scale={scale ? scale : 1}
        />
      </Box>
    );
  }
);

export default SpriteAnimator;
